<template>
  <div>
    <div id="base">
      <div class="side">
        <Sidebar></Sidebar>
      </div>
      <div class="content-outter">
        <div class="content">
          <div class="banner-change">
            <!--  -->
            <div> <img :src="logo"></div>
            <div
              class="dropdown-box"
              @mouseenter="show = true"
              @mouseleave="show = false"
              :class="{ 'active-drop': show }"
            >
              <a class="drop-a">
                <img
                :src="
                  require(`../assets/img/icon-big-lang-${$i18n.locale}.svg`)
                "
                alt="geetest"
                class="flag"/>
              </a>
              <div class="dropdown" :class="{ 'dropdown-show': show }">
                <div @click="changeLange('zh')" class="lang-item">
                  <img
                    src="../assets/img/icon-big-lang-zh.svg"
                    alt="chinese"
                    class="flag"
                  />
                  <span>简体中文</span>
                </div>
                <div @click="changeLange('en')" class="lang-item">
                  <img
                    src="../assets/img/icon-big-lang-en.svg"
                    alt="English"
                    class="flag"
                  />
                  <span>English</span>
                </div>
              </div>
            </div>
          </div>
          <router-view></router-view>
        </div>
        <p class="copyright">
          <a :href="$t('message.terms_link')" target="_blank">{{$t('message.terms')}}</a>
          <a :href="$t('message.privite_link')" target="_blank">{{$t('message.privite')}}</a>
          Copyright © 2012-{{ new Date().getFullYear() }} GeeTest
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { auth } from "api/auth";
import Cookies from "js-cookie";
import store from "store";
import Sidebar from "components/sidebar";
import { updateLocal } from "@/lang";
import { getLang } from "api/auth";
import logo from "assets/img/geetest-logo.svg"
export default {
  data() {
    return {
      "normal-width": "420px",
      
      show: false,
      logo: logo
    };
  },
  computed: {
  },
  methods: {
    changeLange(lang) {
      updateLocal(lang);
      this.$store.commit("setGtlang", lang);
      this.$store.getters.lang;
      getLang({ language: lang }).then((res) => {
        this.show = false;
      });
    },
  },
  components: {
    Sidebar,
  },
  created() {
    auth().then((res) => {
      if (res.data.status == 1) {
        Cookies.set("auth_email", res.data.data.loginname);
        this.$router.push({ path: "/product" });
        return;
      } else {
        // todo 暂时隐藏 强制跳转
        //this.$router.push({ path: '/login' })
      }
    });
    document.title = this.$t('message.insidetitle')
  },
};
</script>
<style rel="stylesheet/less" lang="less">
.card {
  width: 290px;
}
#base {
  width: 100%;
  position: relative;
  div {
    box-sizing: border-box;
  }
  
}
.side {
  width: 420px;
  display: inline-flex;
  position: fixed;
  top: 0;
  bottom: 0;
  z-index: 22;
}
.content-outter {
  width: 100%;
  height: 100%;
  position: relative;
}
.content {
  padding-left: 420px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  @height: 40px;
  min-height: 100vh;
  padding-bottom: 40px;
  flex-direction: column;
  box-sizing: border-box;
}
.banner-change {
  width: calc(~"100% - 420px");
  text-align: right;
  position: fixed;
  top: 0px;
  right: 0px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 26px;
  box-sizing: border-box;
  .flag {
    width: 24px;
    vertical-align: middle;
  }
  .drop-a {
    cursor: pointer;
    position: relative;
    display: inline-block;
    text-align: left;
    color: #3b426b;
    border-radius: 3px;
    padding: 6px;
  }
  .active-drop {
    background-color: #edf1f8;
    border-radius: 3px;
    transition: all 0.3s ease-in-out;
  }
  .dropdown-box {
    display: inline-block;
    position: relative;
    cursor: pointer;
    .dropdown {
      text-align: left;
      opacity: 0;
      position: absolute;
      top: 40px;
      pointer-events: none;
      right: 0px;
      width: 132px;
      background-color: #ffffff;
      border: 1px solid #E1E5ED;
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
      padding: 10px;
      font-size: 14px;
      font-weight: 500;
      letter-spacing: 0.5px;
      color: #3b426b;
      transition: all 0.3s ease-in-out;
      transform: perspective(1400px) rotateX(-15deg);
      border-radius: 6px;
    }
    .lang-item {
      height: 32px;
      line-height: 32px;
      padding: 0 6px;
      cursor: pointer;
      &:hover {
        background: #edf1f8;
        border-radius: 3px;
      }
      &> span {
        line-height: 20px;
        margin-left: 12px;
      }
    }
    .dropdown:before {
      content: "";
      position: absolute;
      background: transparent;
      height: 20px;
      width: 120px;
      top: -20px;
      left: 0;
    }
  }
  .dropdown.dropdown-show {
    opacity: 1;
    transform: rotateX(0);
    pointer-events: auto;
  }
}
.copyright {
  @left: 420px;
  position: absolute;
  left: @left;
  bottom: 22px;
  color: rgba(32, 37, 51, 0.6);;
  text-align: center;
  width: calc(~"100% - @{left}");
  font-size: 12px;
  a {
    margin-right: 40px;
    color: rgb(32, 37, 51 ,0.8);
    &:hover {
      color: #202533;
    }
  }
}
@media screen and (max-width: 1000px) {
  .side {
    display: none;
  }
  .content {
    padding-left: 0;
    width: 100%;
  }
  .copyright {
    left: 0;
    width: 100%;
  }
  .banner-change {
    width: 100%;
  }
}
.input-field {
  position: relative;
  margin-bottom: 18px;
}
.eye-icon {
  position: absolute;
  top: 0px;
  right: 0;
  line-height: 44px;
  height: 44px;
  text-align: center;
  z-index: 2;
  width: 40px;
  font-size: 14px;
  color: #93a2bb;
}
.hide-opcity {
  opacity: 0.3;
}
.geetest-btn {
  background: linear-gradient(180deg, #648cff 0%, #4172fa 100%);
  border: 1px solid rgba(51, 100, 237, 0.35);
  border-radius: 3px;
  box-shadow: inset 0 -2px 0 0 #3262e6, 0 3px 4px 0 rgba(44, 71, 146, 0.32);
  padding: 14px 30px;
  width: 100%;
  cursor: pointer;
  height: 48px;
  font-weight: 500;
  transition: all 0.2s;
  display: inline-block;
  font-size: 13px;
  text-align: center;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  i {
    transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    position: relative;
    left: 2px;
    font-size: 14px;
    font-weight: bold;
  }
  &.disabled {
    pointer-events: none;
    cursor: not-allowed;
    opacity: 0.6;
  }
}
.geetest-btn:hover {
  transform: scale(1) translateY(-4px);
  box-shadow: 0 8px 20px 0 rgba(44, 71, 146, 0.4);
  color: white !important;
  i {
    left: 4px;
    transition: left 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  }
}
</style>



// WEBPACK FOOTER //
// base.vue?96204fba